import React, { useState, useEffect } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import Dropdown from "../../components/Dropdown";
import DropdownFilter from "../../components/DropdownFilter";
import CheckBox from "../../components/CheckBox";
import { post } from "../utils/api";
import { userData, selectedOptic } from "../../js/utils";

import "../css/ProfilesScreen.css";

/*const opticList = [
  {
    id: "",
    text: "",
  },
  {
    id: "0",
    text: "CENTRAL",
  },
  {
    id: "1",
    text: "OPT_1",
  },
  {
    id: "2",
    text: "OPT_2",
  },
]; */

const tokenSesion = userData ? userData.token : "";

export default function ProfilesScreen(props) {
  const [idPerfil, setIdPerfil] = useState(props.profileId);
  const [nombre, setNombre] = useState("");
  const [pacientesEliminarPacientesOpt, setPacientesEliminarPacientesOpt] =
    useState("");
  const [pacientesEliminarOptometriasOpt, setPacientesEliminarOptometriasOpt] =
    useState("");
  const [pacientesEliminarGafasOpt, setPacientesEliminarGafasOpt] =
    useState("");
  const [pacientesEliminarLentillasOpt, setPacientesEliminarLentillasOpt] =
    useState("");
  const [
    pacientesEliminarAudiometriasOpt,
    setPacientesEliminarAudiometriasOpt,
  ] = useState("");
  const [pacientesEliminarAudifonosOpt, setPacientesEliminarAudifonosOpt] =
    useState("");
  const [
    pacientesVerificarOptometriasOpt,
    setPacientesVerificarOptometriasOpt,
  ] = useState("");
  const [pacientesVerificarGafasOpt, setPacientesVerificarGafasOpt] =
    useState("");
  const [pacientesVerificarLentillasOpt, setPacientesVerificarLentillasOpt] =
    useState("");
  const [
    pacientesVerificarAudiometriasOpt,
    setPacientesVerificarAudiometriasOpt,
  ] = useState("");
  const [pacientesVerificarAudifonosOpt, setPacientesVerificarAudifonosOpt] =
    useState("");
  const [datosMinimosPacienteNombre, setDatosMinimosPacienteNombre] =
    useState(true);
  const [datosMinimosPacienteApellidos, setDatosMinimosPacienteApellidos] =
    useState(true);
  const [datosMinimosPacienteDireccion, setDatosMinimosPacienteDireccion] =
    useState(false);
  const [datosMinimosPacienteFNacimiento, setDatosMinimosPacienteFNacimiento] =
    useState(false);
  const [datosMinimosPacienteDNI, setDatosMinmosPacienteDNI] = useState(false);
  const [datosMinimosPacienteMovil, setDatosMinimosPacienteMovil] =
    useState(false);
  const [datosMinimosPacienteEmail, setDatosMinimosPacienteEmail] =
    useState(false);
  const [datosMinimosPacienteRGPDAuto, setDatosMinimosPacientesRGPDAuto] =
    useState(false);
  const [opticaPacientes, setOpticaPacientes] = useState("");
  const [opticaAlmacen, setOpticaAlmacen] = useState("");

  const [listaOpticas, setListaOpticas] = useState([]);
  // const [listaOpticasSelected, setListaOpticasSelected] = useState([]);
  const [listaOpticasSelectedEstado, setListaOpticasSelectedEstado] = useState(
    [],
  );

  const [isLoading, setIsLoading] = useState(false);
  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        const nombreInput = document.getElementById("nombre");
        // Asegúrate de hacer focus al input o elemento interactivo
        if (nombreInput) nombreInput.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    async function loadProfileData() {
      // console.log("PROFILE_ID: ", props.profileId);
      if (props.profileId === -1) {
        setIdPerfil(props.profileId);
        setNombre("");
        setPacientesEliminarPacientesOpt("");
        setPacientesEliminarOptometriasOpt("");
        setPacientesEliminarGafasOpt("");
        setPacientesEliminarLentillasOpt("");
        setPacientesEliminarAudiometriasOpt("");
        setPacientesEliminarAudifonosOpt("");
        setPacientesVerificarOptometriasOpt("");
        setPacientesVerificarGafasOpt("");
        setPacientesVerificarLentillasOpt("");
        setPacientesVerificarAudiometriasOpt("");
        setPacientesVerificarAudifonosOpt("");
        setDatosMinimosPacienteNombre(true);
        setDatosMinimosPacienteApellidos(true);
        setDatosMinimosPacienteDireccion(false);
        setDatosMinimosPacienteFNacimiento(false);
        setDatosMinmosPacienteDNI(false);
        setDatosMinimosPacienteMovil(false);
        setDatosMinimosPacienteEmail(false);
        setDatosMinimosPacientesRGPDAuto(false);
        setOpticaPacientes("");
        setOpticaAlmacen("");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setIdPerfil(props.profileId);

      let json_perfil = [];
      let json_query = { token: tokenSesion, id: props.profileId };

      json_perfil = await post("Configuracion/ObtenerPerfil.php", json_query);

      if (json_perfil) {
        const profileData = {
          nombre: json_perfil.nombre,
          eliminarPaciente: json_perfil.eliminarPaciente,
          eliminarOptometrias: json_perfil.eliminarOptometrias,
          eliminarGafas: json_perfil.eliminarGafas,
          eliminarLentillas: json_perfil.eliminarLentillas,
          eliminarAudiometrias: json_perfil.eliminarAudiometrias,
          eliminarAudifonos: json_perfil.eliminarAudifonos,
          verificarAccionOptometrias: json_perfil.verificarAccionOptometrias,
          verificarAccionGafas: json_perfil.verificarAccionGafas,
          verificarAccionLentillas: json_perfil.verificarAccionLentillas,
          verificarAccionAudiometrias: json_perfil.verificarAccionAudiometrias,
          verificarAccionAudifonos: json_perfil.verificarAccionAudifonos,
          datosMinimosNombre: Boolean(json_perfil.datosMinimosNombre),
          datosMinimosApellidos: Boolean(json_perfil.datosMinimosApellidos),
          datosMinimosDireccion: Boolean(json_perfil.datosMinimosDireccion),
          datosMinimosFechaNacimiento: Boolean(
            json_perfil.datosMinimosFechaNacimiento,
          ),
          datosMinimosDNI: Boolean(json_perfil.datosMinimosDNI),
          datosMinimosMovil: Boolean(json_perfil.datosMinimosMovil),
          datosMinimosEmail: Boolean(json_perfil.datosMinimosEmail),
          datosMinimosLOPDAuto: Boolean(json_perfil.datosMinimosLOPDAuto),
          opticas: json_perfil.opticas,
        };

        //console.log("PROFILE_DATA: ", profileData);

        setNombre(profileData.nombre);
        setPacientesEliminarPacientesOpt(profileData.eliminarPaciente);
        setPacientesEliminarOptometriasOpt(profileData.eliminarOptometrias);
        setPacientesEliminarGafasOpt(profileData.eliminarGafas);
        setPacientesEliminarLentillasOpt(profileData.eliminarLentillas);
        setPacientesEliminarAudiometriasOpt(profileData.eliminarAudiometrias);
        setPacientesEliminarAudifonosOpt(profileData.eliminarAudifonos);
        setPacientesVerificarOptometriasOpt(
          profileData.verificarAccionOptometrias,
        );
        setPacientesVerificarGafasOpt(profileData.verificarAccionGafas);
        setPacientesVerificarLentillasOpt(profileData.verificarAccionLentillas);
        setPacientesVerificarAudiometriasOpt(
          profileData.verificarAccionAudiometrias,
        );
        setPacientesVerificarAudifonosOpt(profileData.verificarAccionAudifonos);
        setDatosMinimosPacienteNombre(Boolean(profileData.datosMinimosNombre));
        setDatosMinimosPacienteApellidos(
          Boolean(profileData.datosMinimosApellidos),
        );
        setDatosMinimosPacienteDireccion(
          Boolean(profileData.datosMinimosDireccion),
        );
        setDatosMinimosPacienteFNacimiento(
          Boolean(profileData.datosMinimosFechaNacimiento),
        );
        setDatosMinmosPacienteDNI(Boolean(profileData.datosMinimosDNI));
        setDatosMinimosPacienteMovil(Boolean(profileData.datosMinimosMovil));
        setDatosMinimosPacienteEmail(Boolean(profileData.datosMinimosEmail));
        setDatosMinimosPacientesRGPDAuto(
          Boolean(profileData.datosMinimosLOPDAuto),
        );
        setListaOpticasSelectedEstado(profileData.opticas);

        setOriginalData(profileData);
      } else {
        setNombre("");
        setPacientesEliminarPacientesOpt("");
        setPacientesEliminarOptometriasOpt("");
        setPacientesEliminarGafasOpt("");
        setPacientesEliminarLentillasOpt("");
        setPacientesEliminarAudiometriasOpt("");
        setPacientesEliminarAudifonosOpt("");
        setPacientesVerificarOptometriasOpt("");
        setPacientesVerificarGafasOpt("");
        setPacientesVerificarLentillasOpt("");
        setPacientesVerificarAudifonosOpt("");
        setDatosMinimosPacienteNombre(true);
        setDatosMinimosPacienteApellidos(true);
        setDatosMinimosPacienteDireccion(false);
        setDatosMinimosPacienteFNacimiento(false);
        setDatosMinmosPacienteDNI(false);
        setDatosMinimosPacienteMovil(false);
        setDatosMinimosPacienteEmail(false);
        setDatosMinimosPacientesRGPDAuto(false);
        setListaOpticasSelectedEstado([]);
      }

      setIsLoading(false);
    }
    loadProfileData();
  }, [props.profileId]);

  useEffect(() => {
    async function loadOpticsData() {
      let json_query = {
        token: tokenSesion,
        idEmpresa: "-1",
      };

      // console.log("JSON_QUERY_PERFILES_OPTICAS: ", json_query);

      let json_opticas = await post(
        "Configuracion/ListarOpticas.php",
        json_query,
      );

      // console.log("JSON_OPTICAS: ", json_opticas);

      if (Array.isArray(json_opticas)) {
        let opticsList = [];
        opticsList.push({ id: -1, text: "" });
        // let opticsListSelected = [];
        for (const el of json_opticas) {
          let optica = { id: el.idOptica, text: el.nombre_corto };
          /* let optica_selected = {
            id: el.idOptica,
            text: el.nombre_corto,
            active: listaOpticasSelectedEstado.includes(el.idOptica),
          }; */
          opticsList.push(optica);
          // opticsListSelected.push(optica_selected);
        }
        setListaOpticas(opticsList);
        // setListaOpticasSelected(opticsListSelected);
      }
    }
    loadOpticsData();
  }, [props.profileId]);

  const saveProfileData = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        id: idPerfil,
        nombre: nombre,
        eliminarPaciente: pacientesEliminarPacientesOpt,
        eliminarOptometrias: pacientesEliminarOptometriasOpt,
        eliminarGafas: pacientesEliminarGafasOpt,
        eliminarLentillas: pacientesEliminarLentillasOpt,
        eliminarAudiometrias: pacientesEliminarAudiometriasOpt,
        eliminarAudifonos: pacientesEliminarAudifonosOpt,
        verificarAccionOptometrias: pacientesVerificarOptometriasOpt,
        verificarAccionGafas: pacientesVerificarGafasOpt,
        verificarAccionLentillas: pacientesVerificarLentillasOpt,
        verificarAccionAudiometrias: pacientesVerificarAudiometriasOpt,
        verificarAccionAudifonos: pacientesVerificarAudifonosOpt,
        datosMinimosNombre: datosMinimosPacienteNombre,
        datosMinimosApellidos: datosMinimosPacienteApellidos,
        datosMinimosDireccion: datosMinimosPacienteDireccion,
        datosMinimosFechaNacimiento: datosMinimosPacienteFNacimiento,
        datosMinimosDNI: datosMinimosPacienteDNI,
        datosMinimosMovil: datosMinimosPacienteMovil,
        datosMinimosEmail: datosMinimosPacienteEmail,
        datosMinimosLOPDAuto: datosMinimosPacienteRGPDAuto,
        idOptica: selectedOptic.id,
        opticas: listaOpticasSelectedEstado,
      };

      let newIdPerfil = -1;
      let error = "";

      console.log("JSON_QUERY_PERFIL: ", json_query);

      await post("Configuracion/GuardarPerfil.php", json_query).then((data) => {
        newIdPerfil = data.id;
        error = data.error;
      });

      if (newIdPerfil === -1) {
        // console.log(error);
        props.createPopupQuestion(
          `Ocurrió un error al grabar los datos.`,
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      } else {
        // Avisamos al padre que se guardó correctamente
        if (props.onSave) {
          props.onSave(newIdPerfil);
        }
        return true;
      }
    }
  };

  const deleteProfileData = async () => {
    let json_query = { token: tokenSesion, idPerfil: idPerfil };
    let deleteError = "";

    await post("Configuracion/EliminarPerfil.php", json_query).then((data) => {
      deleteError = data;
    });

    // console.log("ERROR: ", deleteError);

    if (deleteError !== "") {
      props.createPopupQuestion(
        deleteError,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return false;
    } else {
      if (props.onDelete) {
        props.onDelete();
      }
      return true;
    }
  };

  const minimunData = () => {
    // !! Asegura que el valor devuelto sea siempre true o false
    return !!(
      nombre?.trim() &&
      listaOpticasSelectedEstado?.length > 0 &&
      datosMinimosPacienteNombre &&
      datosMinimosPacienteApellidos
    );
  };

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          discardChanges();
          props.removePopupQuestion();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  const hasChanges = () => {
    if (!originalData) return false;

    // 1. Evaluamos si el array de ópticas cambió (sin importar el orden)
    const opticasOriginales = originalData.opticas || [];

    const opticasDiferentes =
      listaOpticasSelectedEstado.length !== opticasOriginales.length ||
      listaOpticasSelectedEstado.some((id) => !opticasOriginales.includes(id));

    // 2. Comparamos todo apuntando a las "keys" correctas de originalData
    return (
      (nombre || "") !== (originalData.nombre || "") ||
      (pacientesEliminarPacientesOpt || "") !==
        (originalData.eliminarPaciente || "") ||
      (pacientesEliminarOptometriasOpt || "") !==
        (originalData.eliminarOptometrias || "") ||
      (pacientesEliminarGafasOpt || "") !==
        (originalData.eliminarGafas || "") ||
      (pacientesEliminarLentillasOpt || "") !==
        (originalData.eliminarLentillas || "") ||
      (pacientesEliminarAudiometriasOpt || "") !==
        (originalData.eliminarAudiometrias || "") ||
      (pacientesEliminarAudifonosOpt || "") !==
        (originalData.eliminarAudifonos || "") ||
      (pacientesVerificarOptometriasOpt || "") !==
        (originalData.verificarAccionOptometrias || "") ||
      (pacientesVerificarGafasOpt || "") !==
        (originalData.verificarAccionGafas || "") ||
      (pacientesVerificarLentillasOpt || "") !==
        (originalData.verificarAccionLentillas || "") ||
      (pacientesVerificarAudiometriasOpt || "") !==
        (originalData.verificarAccionAudiometrias || "") ||
      (pacientesVerificarAudifonosOpt || "") !==
        (originalData.verificarAccionAudifonos || "") ||
      datosMinimosPacienteNombre !== originalData.datosMinimosNombre ||
      datosMinimosPacienteApellidos !== originalData.datosMinimosApellidos ||
      datosMinimosPacienteDireccion !== originalData.datosMinimosDireccion ||
      datosMinimosPacienteFNacimiento !==
        originalData.datosMinimosFechaNacimiento ||
      datosMinimosPacienteDNI !== originalData.datosMinimosDNI ||
      datosMinimosPacienteMovil !== originalData.datosMinimosMovil ||
      datosMinimosPacienteEmail !== originalData.datosMinimosEmail ||
      datosMinimosPacienteRGPDAuto !== originalData.datosMinimosLOPDAuto ||
      opticasDiferentes
    );
  };

  const discardChanges = () => {
    if (originalData) {
      setNombre(originalData.nombre || "");
      setPacientesEliminarPacientesOpt(originalData.eliminarPaciente || "");
      setPacientesEliminarOptometriasOpt(
        originalData.eliminarOptometrias || "",
      );
      setPacientesEliminarGafasOpt(originalData.eliminarGafas || "");
      setPacientesEliminarLentillasOpt(originalData.eliminarLentillas || "");
      setPacientesEliminarAudiometriasOpt(
        originalData.eliminarAudiometrias || "",
      );
      setPacientesEliminarAudifonosOpt(originalData.eliminarAudifonos || "");
      setPacientesVerificarOptometriasOpt(
        originalData.verificarAccionOptometrias || "",
      );
      setPacientesVerificarGafasOpt(originalData.verificarAccionGafas || "");
      setPacientesVerificarLentillasOpt(
        originalData.verificarAccionLentillas || "",
      );
      setPacientesVerificarAudiometriasOpt(
        originalData.verificarAccionAudiometrias || "",
      );
      setPacientesVerificarAudifonosOpt(
        originalData.verificarAccionAudifonos || "",
      );
      setDatosMinimosPacienteNombre(Boolean(originalData.datosMinimosNombre));
      setDatosMinimosPacienteApellidos(
        Boolean(originalData.datosMinimosApellidos),
      );
      setDatosMinimosPacienteDireccion(
        Boolean(originalData.datosMinimosDireccion),
      );
      setDatosMinimosPacienteFNacimiento(
        Boolean(originalData.datosMinimosFechaNacimiento),
      );
      setDatosMinmosPacienteDNI(Boolean(originalData.datosMinimosDNI));
      setDatosMinimosPacienteMovil(Boolean(originalData.datosMinimosMovil));
      setDatosMinimosPacienteEmail(Boolean(originalData.datosMinimosEmail));
      setDatosMinimosPacientesRGPDAuto(
        Boolean(originalData.datosMinimosLOPDAuto),
      );
      setListaOpticasSelectedEstado(originalData.opticas || []);
    } else {
      setNombre("");
      setPacientesEliminarPacientesOpt("");
      setPacientesEliminarOptometriasOpt("");
      setPacientesEliminarGafasOpt("");
      setPacientesEliminarLentillasOpt("");
      setPacientesEliminarAudiometriasOpt("");
      setPacientesEliminarAudifonosOpt("");
      setPacientesVerificarOptometriasOpt("");
      setPacientesVerificarGafasOpt("");
      setPacientesVerificarLentillasOpt("");
      setPacientesVerificarAudifonosOpt("");
      setDatosMinimosPacienteNombre(true);
      setDatosMinimosPacienteApellidos(true);
      setDatosMinimosPacienteDireccion(false);
      setDatosMinimosPacienteFNacimiento(false);
      setDatosMinmosPacienteDNI(false);
      setDatosMinimosPacienteMovil(false);
      setDatosMinimosPacienteEmail(false);
      setDatosMinimosPacientesRGPDAuto(false);
      setListaOpticasSelectedEstado([]);
    }

    props.closeFunction();
  };

  const checkEliminarPacientesTodoSi = () => {
    return (
      pacientesEliminarPacientesOpt === "Si" &&
      pacientesEliminarOptometriasOpt === "Si" &&
      pacientesEliminarGafasOpt === "Si" &&
      pacientesEliminarLentillasOpt === "Si" &&
      pacientesEliminarAudiometriasOpt === "Si" &&
      pacientesEliminarAudifonosOpt === "Si"
    );
  };

  const checkEliminarPacientesTodoPin = () => {
    return (
      pacientesEliminarPacientesOpt === "Pin" &&
      pacientesEliminarOptometriasOpt === "Pin" &&
      pacientesEliminarGafasOpt === "Pin" &&
      pacientesEliminarLentillasOpt === "Pin" &&
      pacientesEliminarAudiometriasOpt === "Pin" &&
      pacientesEliminarAudifonosOpt === "Pin"
    );
  };

  const checkEliminarPacientesTodoAdmin = () => {
    return (
      pacientesEliminarPacientesOpt === "Admin" &&
      pacientesEliminarOptometriasOpt === "Admin" &&
      pacientesEliminarGafasOpt === "Admin" &&
      pacientesEliminarLentillasOpt === "Admin" &&
      pacientesEliminarAudiometriasOpt === "Admin" &&
      pacientesEliminarAudifonosOpt === "Admin"
    );
  };

  const handleEliminarPacientesOpt = (opt) => {
    if (pacientesEliminarPacientesOpt === opt) {
      setPacientesEliminarPacientesOpt("");
    } else {
      setPacientesEliminarPacientesOpt(opt);
    }
  };

  const handleEliminarOptometriasOpt = (opt) => {
    if (pacientesEliminarOptometriasOpt === opt) {
      setPacientesEliminarOptometriasOpt("");
    } else {
      setPacientesEliminarOptometriasOpt(opt);
    }
  };

  const handleEliminarGafasOpt = (opt) => {
    if (pacientesEliminarGafasOpt === opt) {
      setPacientesEliminarGafasOpt("");
    } else {
      setPacientesEliminarGafasOpt(opt);
    }
  };

  const handleEliminarLentillasOpt = (opt) => {
    if (pacientesEliminarLentillasOpt === opt) {
      setPacientesEliminarLentillasOpt("");
    } else {
      setPacientesEliminarLentillasOpt(opt);
    }
  };

  const handleEliminarAudiometriasOpt = (opt) => {
    if (pacientesEliminarAudiometriasOpt === opt) {
      setPacientesEliminarAudiometriasOpt("");
    } else {
      setPacientesEliminarAudiometriasOpt(opt);
    }
  };

  const handleEliminarAudifonosOpt = (opt) => {
    if (pacientesEliminarAudifonosOpt === opt) {
      setPacientesEliminarAudifonosOpt("");
    } else {
      setPacientesEliminarAudifonosOpt(opt);
    }
  };

  const checkVerificarPacientesTodoPin = () => {
    return (
      pacientesVerificarOptometriasOpt === "Pin" &&
      pacientesVerificarGafasOpt === "Pin" &&
      pacientesVerificarLentillasOpt === "Pin" &&
      pacientesVerificarAudiometriasOpt === "Pin" &&
      pacientesVerificarAudifonosOpt === "Pin"
    );
  };

  const handleVerificarOptometriasOpt = (opt) => {
    if (pacientesVerificarOptometriasOpt === opt) {
      setPacientesVerificarOptometriasOpt("");
    } else {
      setPacientesVerificarOptometriasOpt(opt);
    }
  };

  const handleVerificarGafasOpt = (opt) => {
    if (pacientesVerificarGafasOpt === opt) {
      setPacientesVerificarGafasOpt("");
    } else {
      setPacientesVerificarGafasOpt(opt);
    }
  };

  const handleVerificarLentillasOpt = (opt) => {
    if (pacientesVerificarLentillasOpt === opt) {
      setPacientesVerificarLentillasOpt("");
    } else {
      setPacientesVerificarLentillasOpt(opt);
    }
  };

  const handleVerificarAudiometriasOpt = (opt) => {
    if (pacientesVerificarAudiometriasOpt === opt) {
      setPacientesVerificarAudiometriasOpt("");
    } else {
      setPacientesVerificarAudiometriasOpt(opt);
    }
  };

  const handleVerificarAudifonosOpt = (opt) => {
    if (pacientesVerificarAudifonosOpt === opt) {
      setPacientesVerificarAudifonosOpt("");
    } else {
      setPacientesVerificarAudifonosOpt(opt);
    }
  };

  const checkDatosMinimosPacientesTodoTrue = () => {
    return (
      datosMinimosPacienteNombre &&
      datosMinimosPacienteApellidos &&
      datosMinimosPacienteDireccion &&
      datosMinimosPacienteFNacimiento &&
      datosMinimosPacienteDNI &&
      datosMinimosPacienteMovil &&
      datosMinimosPacienteEmail &&
      datosMinimosPacienteRGPDAuto
    );
  };

  /*if (!props.show) {
    return <></>;
  }*/

  /*if (isLoading) {
    return <div className="spinner" />;
  }*/

  const opcionesCalculadasFiltro = listaOpticas
    .filter((opt) => opt.id !== -1)
    .map((opt) => ({
      id: opt.id, // Mantenemos el tipo original (probablemente Number)
      text: opt.text,
      // Comparamos forzando a String temporalmente para evitar fallos
      active: listaOpticasSelectedEstado.some(
        (selecId) => String(selecId) === String(opt.id),
      ),
    }));

  return (
    <div className="profile-popup-container">
      <div className="profile-popup-screen">
        <div className="profile-popup-screen-header">
          <button className="popup-action-icon close-icon">
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt="Icon"
              onClick={() => {
                handleClose();
              }}
            ></img>
          </button>
          <span className="popup-screen-header-title">Datos de perfil</span>
        </div>
        <div className="profile-section-content">
          <div className="profile-container-block">
            <div className="profile-data-field-row">
              <div className="profile-data-field d-profile-small">
                <span className="label">Nombre (*)</span>
                <InputData
                  tabIndex={1}
                  id="nombre"
                  type="type-type-alphanum-ext"
                  size={6}
                  input={nombre}
                  onChange={(e) => {
                    setNombre(e);
                  }}
                />
              </div>
            </div>
            <div className="profile-data-field-row">
              <div className="profile-data-field d-profile-large">
                <span className="label">Ópticas (*)</span>
                <DropdownFilter
                  disabled={false}
                  optionList={opcionesCalculadasFiltro}
                  op={"ÓPTICAS"}
                  selectedOptions={listaOpticasSelectedEstado}
                  onChange={(e) => {
                    // 1. Comprobamos si el ID ya está seleccionado (comparando como textos)
                    const existe = listaOpticasSelectedEstado.some(
                      (id) => String(id) === String(e.id),
                    );

                    // 2. Filtramos o añadimos conservando el tipo de dato original de e.id
                    const updatedOpticasSelectedEstado = existe
                      ? listaOpticasSelectedEstado.filter(
                          (id) => String(id) !== String(e.id),
                        )
                      : [...listaOpticasSelectedEstado, e.id];

                    setListaOpticasSelectedEstado(updatedOpticasSelectedEstado);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="profile-container-block">
            <div className="profile-data-field-row">
              <span className="profile-h3-black">Historial de pacientes</span>
            </div>
            <div className="profile-data-field-row">
              <div className="breaker-gr mb-8" />
              <div className="profile-data-row-item" />
            </div>
            <div className="profile-section-content-data">
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <span className="profile-h4">Eliminar (a la papelera)</span>
                </div>
                <div className="profile-data-row-item">
                  <span className="profile-h4">Verificar acción de agente</span>
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="breaker-gr mb-8" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item">
                  <div className="breaker-gr mb-8" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4" />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelTodoSi"
                      tabIndex={2}
                      active={checkEliminarPacientesTodoSi()}
                      onClick={() => {
                        const estanTodosSi = checkEliminarPacientesTodoSi();

                        const nuevoValor = estanTodosSi ? "" : "Si";

                        setPacientesEliminarPacientesOpt(nuevoValor);
                        setPacientesEliminarOptometriasOpt(nuevoValor);
                        setPacientesEliminarGafasOpt(nuevoValor);
                        setPacientesEliminarLentillasOpt(nuevoValor);
                        setPacientesEliminarAudiometriasOpt(nuevoValor);
                        setPacientesEliminarAudifonosOpt(nuevoValor);
                      }}
                    />
                    <span className="profile-h4">Sí</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelTodoPin"
                      tabIndex={2}
                      active={checkEliminarPacientesTodoPin()}
                      onClick={() => {
                        const estanTodosPin = checkEliminarPacientesTodoPin();

                        const nuevoValor = estanTodosPin ? "" : "Pin";

                        setPacientesEliminarPacientesOpt(nuevoValor);
                        setPacientesEliminarOptometriasOpt(nuevoValor);
                        setPacientesEliminarGafasOpt(nuevoValor);
                        setPacientesEliminarLentillasOpt(nuevoValor);
                        setPacientesEliminarAudiometriasOpt(nuevoValor);
                        setPacientesEliminarAudifonosOpt(nuevoValor);
                      }}
                    />
                    <span className="profile-h4">Pin</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelAdmin"
                      tabIndex={2}
                      active={checkEliminarPacientesTodoAdmin()}
                      onClick={() => {
                        const estanTodosAdmin =
                          checkEliminarPacientesTodoAdmin();

                        const nuevoValor = estanTodosAdmin ? "" : "Admin";

                        setPacientesEliminarPacientesOpt(nuevoValor);
                        setPacientesEliminarOptometriasOpt(nuevoValor);
                        setPacientesEliminarGafasOpt(nuevoValor);
                        setPacientesEliminarLentillasOpt(nuevoValor);
                        setPacientesEliminarAudiometriasOpt(nuevoValor);
                        setPacientesEliminarAudifonosOpt(nuevoValor);
                      }}
                    />
                    <span className="profile-h4">Admin</span>
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacVerPin"
                      tabIndex={2}
                      active={checkVerificarPacientesTodoPin()}
                      onClick={() => {
                        const estanTodosPin = checkVerificarPacientesTodoPin();

                        const nuevoValor = estanTodosPin ? "" : "Pin";

                        setPacientesVerificarOptometriasOpt(nuevoValor);
                        setPacientesVerificarGafasOpt(nuevoValor);
                        setPacientesVerificarLentillasOpt(nuevoValor);
                        setPacientesVerificarAudiometriasOpt(nuevoValor);
                        setPacientesVerificarAudifonosOpt(nuevoValor);
                      }}
                    />
                    <span className="profile-h4">Pin</span>
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Pacientes</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelSi"
                      tabIndex={2}
                      active={pacientesEliminarPacientesOpt === "Si"}
                      onClick={() => handleEliminarPacientesOpt("Si")}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelPin"
                      tabIndex={2}
                      active={pacientesEliminarPacientesOpt === "Pin"}
                      onClick={() => handleEliminarPacientesOpt("Pin")}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="pacDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarPacientesOpt === "Admin"}
                      onClick={() => handleEliminarPacientesOpt("Admin")}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Optometrías</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="optDelSi"
                      tabIndex={2}
                      active={pacientesEliminarOptometriasOpt === "Si"}
                      onClick={() => {
                        handleEliminarOptometriasOpt("Si");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="optDelPin"
                      tabIndex={2}
                      active={pacientesEliminarOptometriasOpt === "Pin"}
                      onClick={() => {
                        handleEliminarOptometriasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="optDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarOptometriasOpt === "Admin"}
                      onClick={() => {
                        handleEliminarOptometriasOpt("Admin");
                      }}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Optometrías</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="optVerPin"
                      tabIndex={2}
                      active={pacientesVerificarOptometriasOpt === "Pin"}
                      onClick={() => {
                        handleVerificarOptometriasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Gafas</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="gafDelSi"
                      tabIndex={2}
                      active={pacientesEliminarGafasOpt === "Si"}
                      onClick={() => {
                        handleEliminarGafasOpt("Si");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="gafDelPin"
                      tabIndex={2}
                      active={pacientesEliminarGafasOpt === "Pin"}
                      onClick={() => {
                        handleEliminarGafasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="gafDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarGafasOpt === "Admin"}
                      onClick={() => {
                        handleEliminarGafasOpt("Admin");
                      }}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Gafas</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="gafVerPin"
                      tabIndex={2}
                      active={pacientesVerificarGafasOpt === "Pin"}
                      onClick={() => {
                        handleVerificarGafasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Lentes de contacto</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="lenDelSi"
                      tabIndex={2}
                      active={pacientesEliminarLentillasOpt === "Si"}
                      onClick={() => {
                        handleEliminarLentillasOpt("Si");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="lenDelPin"
                      tabIndex={2}
                      active={pacientesEliminarLentillasOpt === "Pin"}
                      onClick={() => {
                        handleEliminarLentillasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="lenDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarLentillasOpt === "Admin"}
                      onClick={() => {
                        handleEliminarLentillasOpt("Admin");
                      }}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Lentes de contacto</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="lenVerPin"
                      tabIndex={2}
                      active={pacientesVerificarLentillasOpt === "Pin"}
                      onClick={() => {
                        handleVerificarLentillasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Audiometrías</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audiDelSi"
                      tabIndex={2}
                      active={pacientesEliminarAudiometriasOpt === "Si"}
                      onClick={() => {
                        handleEliminarAudiometriasOpt("Si");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audiDelPin"
                      tabIndex={2}
                      active={pacientesEliminarAudiometriasOpt === "Pin"}
                      onClick={() => {
                        handleEliminarAudiometriasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audiDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarAudiometriasOpt === "Admin"}
                      onClick={() => {
                        handleEliminarAudiometriasOpt("Admin");
                      }}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Audiometrías</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audiVerPin"
                      tabIndex={2}
                      active={pacientesVerificarAudiometriasOpt === "Pin"}
                      onClick={() => {
                        handleVerificarAudiometriasOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Audifonos</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audDelSi"
                      tabIndex={2}
                      active={pacientesEliminarAudifonosOpt === "Si"}
                      onClick={() => {
                        handleEliminarAudifonosOpt("Si");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audDelPin"
                      tabIndex={2}
                      active={pacientesEliminarAudifonosOpt === "Pin"}
                      onClick={() => {
                        handleEliminarAudifonosOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audDelAdmin"
                      tabIndex={2}
                      active={pacientesEliminarAudifonosOpt === "Admin"}
                      onClick={() => {
                        handleEliminarAudifonosOpt("Admin");
                      }}
                    />
                  </div>
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Audifonos</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="audVerPin"
                      tabIndex={2}
                      active={pacientesVerificarAudifonosOpt === "Pin"}
                      onClick={() => {
                        handleVerificarAudifonosOpt("Pin");
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
            </div>
          </div>
          <div className="profile-container-block">
            <div className="profile-data-field-row">
              <span className="profile-h3-black">
                Datos mínimos para el alta de pacientes
              </span>
            </div>
            <div className="profile-data-field-row">
              <div className="breaker-gr mb-8" />
              <div className="profile-data-row-item" />
            </div>
            <div className="profile-section-content-data">
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4" />
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinTodos"
                      tabIndex={2}
                      active={checkDatosMinimosPacientesTodoTrue()}
                      onClick={() => {
                        const estanTodosFalse =
                          checkDatosMinimosPacientesTodoTrue();

                        const nuevoValor = estanTodosFalse ? false : true;

                        setDatosMinimosPacienteNombre(nuevoValor);
                        setDatosMinimosPacienteApellidos(nuevoValor);
                        setDatosMinimosPacienteDireccion(nuevoValor);
                        setDatosMinimosPacienteFNacimiento(nuevoValor);
                        setDatosMinmosPacienteDNI(nuevoValor);
                        setDatosMinimosPacienteMovil(nuevoValor);
                        setDatosMinimosPacienteEmail(nuevoValor);
                        setDatosMinimosPacientesRGPDAuto(nuevoValor);
                      }}
                    />
                    <span className="profile-h4">Sí</span>
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Nombre (*)</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinNombre"
                      tabIndex={2}
                      active={datosMinimosPacienteNombre}
                      onClick={() => {
                        setDatosMinimosPacienteNombre(
                          !datosMinimosPacienteNombre,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Apellidos (*)</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinApellidos"
                      tabIndex={2}
                      active={datosMinimosPacienteApellidos}
                      onClick={() => {
                        setDatosMinimosPacienteApellidos(
                          !datosMinimosPacienteApellidos,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Dirección</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinDireccion"
                      tabIndex={2}
                      active={datosMinimosPacienteDireccion}
                      onClick={() => {
                        setDatosMinimosPacienteDireccion(
                          !datosMinimosPacienteDireccion,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">F. Nacimiento</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinFNacimiento"
                      tabIndex={2}
                      active={datosMinimosPacienteFNacimiento}
                      onClick={() => {
                        setDatosMinimosPacienteFNacimiento(
                          !datosMinimosPacienteFNacimiento,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">DNI</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinDNI"
                      tabIndex={2}
                      active={datosMinimosPacienteDNI}
                      onClick={() => {
                        setDatosMinmosPacienteDNI(!datosMinimosPacienteDNI);
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Móvil</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinMovil"
                      tabIndex={2}
                      active={datosMinimosPacienteMovil}
                      onClick={() => {
                        setDatosMinimosPacienteMovil(
                          !datosMinimosPacienteMovil,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">Email</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinEmail"
                      tabIndex={2}
                      active={datosMinimosPacienteEmail}
                      onClick={() => {
                        setDatosMinimosPacienteEmail(
                          !datosMinimosPacienteEmail,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
              <div className="profile-data-row">
                <div className="profile-data-row-item">
                  <div className="profile-data-row-item">
                    <span className="profile-h4">RGPD auto</span>
                  </div>
                  <div className="profile-data-row-item">
                    <CheckBox
                      id="datMinRGPD"
                      tabIndex={2}
                      active={datosMinimosPacienteRGPDAuto}
                      onClick={() => {
                        setDatosMinimosPacientesRGPDAuto(
                          !datosMinimosPacienteRGPDAuto,
                        );
                      }}
                    />
                  </div>
                  <div className="profile-data-row-item" />
                  <div className="profile-data-row-item" />
                </div>
                <div className="profile-data-row-item" />
              </div>
            </div>
          </div>
          <div className="profile-container-block">
            <div className="profile-data-field-row">
              <span className="profile-h3-black">Configuración multipunto</span>
            </div>
            <div className="profile-data-field-row">
              <div className="breaker-gr mb-8" />
              <div className="profile-data-row-item" />
            </div>
            <div className="profile-data-field-row">
              <div className="profile-data-field d-profile-small">
                <span className="label">Pacientes</span>
                <Dropdown
                  tabIndex={7}
                  id="provincia"
                  disabled={false}
                  optionList={listaOpticas}
                  size={3}
                  op={opticaPacientes}
                  onChange={(e) => {
                    setOpticaPacientes(e.id);
                  }}
                />
              </div>
            </div>
            <div className="profile-data-field-row">
              <div className="profile-data-field d-profile-small">
                <span className="label">Almacén</span>
                <Dropdown
                  tabIndex={7}
                  id="provincia"
                  disabled={false}
                  optionList={listaOpticas}
                  size={3}
                  op={opticaAlmacen}
                  onChange={(e) => {
                    setOpticaAlmacen(e.id);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="popup-row-buttons-container">
          <div className="popup-row-buttons profile-menu">
            <ButtonIconH
              text="Cancelar"
              onClick={() => {
                handleClose();
              }}
            />
            <ButtonIconH
              text="Guardar"
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea guardar los cambios realizados en este perfil?`,
                  async () => {
                    const guardadoExitoso = await saveProfileData();

                    if (guardadoExitoso) {
                      props.removePopupQuestion();
                      // props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
            <ButtonIconH
              text="Eliminar"
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea eliminar el perfil actual?`,
                  async () => {
                    const borradoExitoso = await deleteProfileData();

                    if (borradoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
